"use client";

import { useState } from "react";

import type { TUseSheets } from "./useSheets.config";

export const useSheets = <TSheet extends string>(): TUseSheets<TSheet> => {
  const [ activeSheet, setActiveSheet ] = useState<TSheet | null>(null);

  const isOpen = (key: TSheet) => activeSheet === key;

  const onOpen = (key: TSheet) => setActiveSheet(key);

  const onClose = () => {
    setActiveSheet(null);
  };

  return {
    isOpen,
    onOpen,
    onClose,
  };
};
